import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { creerCompteReducer } from './creerCompteReducer';
import {
    CONTEXT_COMPTE_CREER_MOTIF,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE,
    CONTEXT_CREER_COMPTE_ETAPE_IDENTITE,
    CONTEXT_CREER_COMPTE_ETAPE_PERSONNE_MORALE,
    CONTEXT_CREER_COMPTE_ETAPE_RESPONSABLE_LEGAL,
    CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_FINALISER,
    CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_VALIDATION_TOKEN,
    CONTEXT_CREER_COMPTE_ETAPE_VALIDATION,
    CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_GENERATION_PDF_LOGIN,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES_RESPONSABLE_LEGAL_MINEUR,
    CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2,
    CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2,
    CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE,
    CONTEXT_ENREGISTRER_VERSO_LICENCE_TIR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_VERSO_LICENCE_SKI_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_VERSO_LICENCE_BALLTRAP_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_AUTORISATION_DETENTION_ARME_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_AUTORISATION_EXERCICE_PERSONNE_MORALE,
    CONTEXT_ENREGISTRER_PREUVE_AUTORITE_PARENTALE,
    CONTEXT_ENREGISTRER_CERTIFICAT_HONNEUR,
    CONTEXT_ENREGISTRER_PIECE_JUSTIFICATIVE_MINEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_PIECE_IDENTITE_RESPONSABLE_LEGAL,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_RESPONSABLE_LEGAL,
    CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_ADRESSE_RESPONSABLE_LEGAL,
} from '../../../constants/apiUrls.constants';

const creer = combineReducers({
    statutCompteMetierAsso: creerCompteReducer,
    choisirMotif: APIReducer.bind(null, CONTEXT_COMPTE_CREER_MOTIF),
    renseignerIdentite: APIReducer.bind(null, CONTEXT_CREER_COMPTE_ETAPE_IDENTITE),
    creerPersonneMorale: APIReducer.bind(null, CONTEXT_CREER_COMPTE_ETAPE_PERSONNE_MORALE),
    renseignerAutorisationsExercice: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_AUTORISATION_EXERCICE_PERSONNE_MORALE,
    ),
    renseignerPiecesIdentite: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2,
    ),
    renseignerAdressePrincipale: APIReducer.bind(
        null,
        CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE,
    ),
    renseignerCertificatMedicalArs: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE,
    ),
    renseignerJustificatifsDomicile: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2,
    ),
    renseignerPermisDeChasse: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    ),

    renseignerAutorisationPortArme: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_AUTORISATION_DETENTION_ARME_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    ),

    renseignerValidationPermisChasser: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    ),
    renseignerVersoLicenceTir: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_VERSO_LICENCE_TIR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    ),
    renseignerVersoLicenceSki: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_VERSO_LICENCE_SKI_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    ),
    renseignerVersoLicenceBallTrap: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_VERSO_LICENCE_BALLTRAP_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    ),
    renseignerResponsableLegal: APIReducer.bind(null, CONTEXT_CREER_COMPTE_ETAPE_RESPONSABLE_LEGAL),
    renseignerPreuveAutoriteParentale: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_PREUVE_AUTORITE_PARENTALE,
    ),
    renseignerCertificatHonneur: APIReducer.bind(null, CONTEXT_ENREGISTRER_CERTIFICAT_HONNEUR),
    renseignerPieceIdentiteResponsableLegal: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_PIECE_IDENTITE_RESPONSABLE_LEGAL,
    ),

    renseignerPieceJustificativeMineur: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_PIECE_JUSTIFICATIVE_MINEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    ),

    renseignerCarteCollectionneur: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    ),

    validation: APIReducer.bind(null, CONTEXT_CREER_COMPTE_ETAPE_VALIDATION),
    validationToken: APIReducer.bind(null, CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_VALIDATION_TOKEN),
    finaliserCreationCompte: APIReducer.bind(null, CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_FINALISER),
    fichierPdfBase64: APIReducer.bind(
        null,
        CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_GENERATION_PDF_LOGIN,
    ),
    ajoutAdresseSecondaire: APIReducer.bind(null, CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES),
    ajoutAdresseSecondaireResponsableLegalMineur: APIReducer.bind(
        null,
        CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES_RESPONSABLE_LEGAL_MINEUR,
    ),
    renseignerAdresseResponsableLegal: APIReducer.bind(
        null,
        CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_RESPONSABLE_LEGAL,
    ),
    renseignerJustificatifsDomicileResponsableLegal: APIReducer.bind(
        null,
        CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_ADRESSE_RESPONSABLE_LEGAL,
    ),
});

export default creer;
